export const ID_NUMBER = "NUMER_IDENTYFIKACYJNY";

export const isIdentityType = (value: any) => {
    var regex: RegExp = /^\d{6}$/;
    return regex.test(value);
}

export const padZeros = (value: number) => {
    const strValue = value?.toString();
    return strValue?.padStart(6, '0');
}